import { useState } from 'react';
import { Link } from 'react-router-dom';
import StoryCard from '@/components/base/StoryCard';
import SectionHeading from '@/components/base/SectionHeading';
import { categories, filterStories } from '@/lib/content';

const TABS = [{ key: 'all', name: '全部' }, ...categories.map((c) => ({ key: c.key, name: c.name }))];

export default function FeaturedFeed() {
  const [active, setActive] = useState('all');
  const list = filterStories({ category: active }).slice(0, 6);

  return (
    <section className="w-full border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            kicker="Hot feed"
            title="热门爆料 · 卡片速览流"
            desc="每张卡片都是一条完整的速览：标题、精简摘要和关键要点，点进去可以看完整整理。"
          />
          <Link
            to="/hot"
            className="inline-flex items-center gap-1 whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            进入完整列表页
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 font-label text-sm transition-colors ${
                active === tab.key
                  ? 'bg-primary-500 text-background-50'
                  : 'border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((story) => (
              <StoryCard key={story.id} story={story} />
            ))}
          </div>
        ) : (
          <p className="mt-10 rounded-lg border border-background-300 bg-background-50 p-8 text-center font-body text-sm text-foreground-600">
            这个板块暂时还没有速览内容，换个分类看看吧。
          </p>
        )}
      </div>
    </section>
  );
}